import './Demo.css';
import Grease from "../../assets/grease.png";
import Bubba from "../../assets/bubba.png";

function Demo() {
return (
    <div className="App main">
        <div className="resume">
            <div className="site-banner-header">
                <h1 className="resume">
                Demo
                </h1>
            </div>

            <div>
                <div>
                <div className="project-container card-overlay card-overlay-hover card">
                <a href="https://cristenrh.github.io/grease/" title="">
                    <div className="demo section-media"  >
                        <img src="" className="img-responsive" />
                    </div>
                    <div className="card-overlay-panel card-overlay-bottom card-overlay-background card-overlay-slide-bottom">
                    <div className="card-overlay-title">
                        <h4 className="demo" >ACADEMICS</h4>
                    </div>
                    <div className="card-overlay-panel">
                        <p>Tuition alone does not cover the full cost of an exceptional Trinity education. Your giving allows us to hire the best teachers, deliver incredible programs, and nurture the whole child.</p>
                    </div>
                    </div>
                    </a>
                </div>
                </div>
            </div>
{/* 
<h4 className="mt-6">Spinner</h4>

<div className="spin-container">
	
	<svg className="spin-loader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340">
		 <circle cx="170" cy="170" r="160" stroke="#E2007C"/>
	
	</svg>
	
</div> */}


            </div>
        </div>
    );
  }
  
  export default Demo;
  